var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"s-insertion",class:_vm.basicClassName,attrs:{"id":_vm.id}},[_c('a-dangerous-html',{staticClass:"s-insertion__text",attrs:{"content":_vm.l10n.lead}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }